import React from 'react';
import PropTypes from 'prop-types';
import {
  FileDropzone,
  InputText,
  Radio,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
  FileDropzoneCloser,
} from '../../../Shared';

import {
  allowedFileTypesString,
  inputTheme,
  inputThemeShort,
  maxFileSize,
  radioTheme,
} from '../../../lib';


const formName = 'Name Plates';

const defaultValues = {
  'Quantity': '',
  'Size': '',
  'Material': '',
  'Name-for-plate': '',
  'Title-for-plate': '',
  'Attachments': '',
  'Holders': '',
  'Colour': '',
  'Application': '',
  'Match-existing-signage': '',
};

const fields = [
  'Quantity',
  'Size',
  'Material',
  'Name-for-plate',
  'Title-for-plate',
  'Attachments',
  'Holders',
  'Colour',
  'Application',
  'Match-existing-signage',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <InputText
        inputTextId='Size'
        inputTextName='Size'
        register={register}
        formState={formState}
        label='Size'
        theme={inputThemeShort}
      />

      <Radio
        radioId='Material'
        radioName='Material'
        legend='Material?'
        options={[
          { value: 'plastic', label: 'Plastic' },
          { value: 'metal', label: 'Metal' },
          { value: 'modular', label: 'Modular' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={radioTheme}
      />

      <InputText
        inputTextId='Name-for-plate'
        inputTextName='Name-for-plate'
        register={register}
        formState={formState}
        label='Name'
        theme={inputTheme}
      />

      <InputText
        inputTextId='Title-for-plate'
        inputTextName='Title-for-plate'
        register={register}
        formState={formState}
        label='Title'
        theme={inputTheme}
      />

      <FileDropzone
        fileId='Attachments'
        fileName='Attachments'
        label='Please attach a file of your logo, if applicable.'
        register={register}
        unregister={unregister}
        setValue={setValue}
        control={control}
        watch={watch}
        formState={formState}
        allowedExtensions={allowedFileTypesString}
        maxFileSize={maxFileSize}
      >
        <FileDropzoneCloser />
      </FileDropzone>

      <Radio
        radioId='Holders'
        radioName='Holders'
        legend='Holders'
        options={[
          { value: 'wall-mount', label: 'Wall mount' },
          { value: 'desk-mount', label: 'Desk mount' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <InputText
        inputTextId='Colour'
        inputTextName='Colour'
        register={register}
        formState={formState}
        label='Colour'
        theme={inputTheme}
      />

      <Radio
        radioId='Application'
        radioName='Application'
        legend='Application'
        options={[
          { value: 'holes', label: 'Holes' },
          { value: 'adhesive', label: 'Adhesive' },
          { value: 'magnetic', label: 'Magnetic' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={radioTheme}
      />

      <Radio
        radioId='Match-existing-signage'
        radioName='Match-existing-signage'
        legend='Are we matching existing signage?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
